module.exports = __webpack_public_path__ + "img/contango.585c7f1a.svg";